/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-16 11:00:56
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-01 18:54:50
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ConfigProvider/slice.ts
 */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { EnumReducers } from 'src/store/constants';
import { generateKey } from 'src/tools/getUserInfo';
import {
  STORE_DATE_FORMAT,
  STORE_UTC,
  STORE_TIME_FORMAT,
  STORE_TIMEZONE,
} from 'src/tools/constant';

const INITIAL_STATE = {
  linkList: [],
  currencies: [],
  basicSetting: null,
  areaCodes: [],
  salesChannels: [],
};

const configProvider = createSlice({
  name: 'config',
  initialState: INITIAL_STATE,
  reducers: {
    onInitState: (state, action) => {
      state.linkList = action.payload;
    },
    onInitCurrencies: (state, action) => {
      state.currencies = action.payload;
    },
    onBasicSettingChange: (state, action) => {
      state.basicSetting = action.payload;
      const { dateFormat, timeFormat, timezoneGmt, timezone } = action.payload;
      const kD = generateKey(STORE_DATE_FORMAT);
      const kT = generateKey(STORE_TIME_FORMAT);
      const kU = generateKey(STORE_UTC);
      const kZ = generateKey(STORE_TIMEZONE);
      localStorage.setItem(kD, (dateFormat || '').toUpperCase());
      localStorage.setItem(kT, timeFormat || '');
      localStorage.setItem(kU, timezoneGmt || '');
      localStorage.setItem(kZ, timezone || '');
    },
    onAreaCodeChange: (state, action) => {
      state.areaCodes = action.payload;
    },
    onSalesChannelsChange: (state, action) => {
      state.salesChannels = action.payload;
    },
  },
});

export const getConfig = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].linkList,
    (v) => v,
  );

export const getAreaCodes = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].areaCodes,
    (v) => v,
  );

export const getCurrencies = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].currencies,
    (v) => v || [],
  );

export const getBasicSetting = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].basicSetting,
    (v) => v || {},
  );

export const getDateFormat = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].basicSetting,
    (v) => get(v, 'dateFormat'),
  );

export const getTimeFormat = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].basicSetting,
    (v) => get(v, 'timeFormat'),
  );
export const getTimezone = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].basicSetting,
    (v) => get(v, 'timezone'),
  );
export const getIDOfTimezone = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].basicSetting,
    (v) => get(v, 'timezoneLocale', 'Asia/Shanghai'),
  );

export const getReportingCurrencies = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].currencies,
    (v) => {
      const c =
        v.find((i) => {
          return i.reportingCurrency;
        }) || {};
      return c.code;
    },
  );

export const getSalesChannels = () =>
  createSelector(
    (state: any) => state[EnumReducers.configProvider].salesChannels,
    (v) => v || [],
  );

export const {
  onInitState,
  onInitCurrencies,
  onBasicSettingChange,
  onAreaCodeChange,
  onSalesChannelsChange,
} = configProvider.actions;

export default configProvider.reducer;
